/**
 * getOtelParamsFromInstrumentationParams converts InstrumentationParams into a simple string:string dictionary for OTEL telemetry logging.
 * @param clickParams The click parameters, a dictionary that can contain other dictionaries (such as SafeStrings or ConditionalStrings)
 * @return The parsed-out key-value string pairs to use for telemetry purposes (logFeature).
 */
export function getOtelParamsFromInstrumentationParams(clickParams) {
    var _a;
    var params = {};
    if (!clickParams) {
        return params;
    }
    for (var key in clickParams) {
        var value = clickParams[key];
        var updatedValue = '';
        if (typeof value === 'object') {
            if ('value' in value) {
                updatedValue = value['value'];
            }
            if ('defaultValue' in value) {
                var defaultValue = value['defaultValue'];
                if (typeof defaultValue === 'object') {
                    updatedValue = defaultValue['value'];
                }
                else {
                    updatedValue = defaultValue;
                }
            }
        }
        else {
            updatedValue = (_a = value) !== null && _a !== void 0 ? _a : '';
        }
        params[key] = updatedValue;
    }
    return params;
}
//# sourceMappingURL=getOtelParamsFromInstrumentationParams.js.map